import { HOME_PAGE_SLUGS } from 'utils/constants';
import { AppRouteGroup } from 'utils/routing/AppRouteGroup';

import {
  GRAD_PROGRAM_URL_SEGMENTS,
  INTERNSHIP_URL_SEGMENTS,
  JOB_URL_SEGMENTS,
  ORG_TYPE_URL_SEGMENTS,
  VOLOP_URL_SEGMENTS,
  combinedOrgTypeAndInternshipUrlSegments,
  combinedOrgTypeAndJobUrlSegments,
} from './mainRouteSegments';

export const mainRouteGroup = new AppRouteGroup({
  path: '/:lang',
  params: ['lang'],
});

export const mainHomeRoute = mainRouteGroup.route({ path: '' });

// Org

export const mainOrgSegmentedRoutes = ORG_TYPE_URL_SEGMENTS.flatMap(
  (orgTypeUrlSegment) => [
    mainRouteGroup.route({
      path: `${orgTypeUrlSegment}/:orgIdDashSlug`,
      params: ['orgIdDashSlug'],
    }),
    mainRouteGroup.route({
      path: `amp/${orgTypeUrlSegment}/:orgIdDashSlug`,
      params: ['orgIdDashSlug'],
    }),
  ],
);

// Jobs

export const mainJobSegmentedRoutes = [
  ...JOB_URL_SEGMENTS,
  ...combinedOrgTypeAndJobUrlSegments,
].flatMap((jobUrlSegment) => [
  mainRouteGroup.route({
    path: `${jobUrlSegment}/:jobIdDashSlug`,
    params: ['jobIdDashSlug'],
  }),
  mainRouteGroup.route({
    path: `amp/${jobUrlSegment}/:jobIdDashSlug`,
    params: ['jobIdDashSlug'],
  }),
]);

const mainJobsSearchRouteReference = mainRouteGroup.route({
  path: ':segment',
  params: ['segment'],
  searchParams: ['q'],
});

export function getMainJobsSearchRoutePath(data: {
  lang: UserLocale;
  q: string;
}) {
  const { lang, q } = data;
  const segment = HOME_PAGE_SLUGS.JOB[lang];

  return mainJobsSearchRouteReference.with({ lang, segment, q });
}

// Internship

export const mainInternshipSegmentedRoutes = [
  ...Object.values(INTERNSHIP_URL_SEGMENTS),
  ...combinedOrgTypeAndInternshipUrlSegments,
].flatMap((internshipUrlSegment) => [
  mainRouteGroup.route({
    path: `${internshipUrlSegment}/:internshipIdDashSlug`,
    params: ['internshipIdDashSlug'],
  }),
  mainRouteGroup.route({
    path: `amp/${internshipUrlSegment}/:internshipIdDashSlug`,
    params: ['internshipIdDashSlug'],
  }),
]);

const mainInternshipsSearchRouteReference = mainRouteGroup.route({
  path: ':segment',
  params: ['segment'],
  searchParams: ['q'],
});

export function getMainInternshipsSearchRoutePath(data: {
  lang: UserLocale;
  q: string;
}) {
  const { lang, q } = data;
  const segment = HOME_PAGE_SLUGS.INTERNSHIP[lang];

  return mainInternshipsSearchRouteReference.with({ lang, segment, q });
}

// Volop

export const mainVolopSegmentedRoutes = VOLOP_URL_SEGMENTS.flatMap(
  (volopUrlSegment) => [
    mainRouteGroup.route({
      path: `${volopUrlSegment}/:volopIdDashSlug`,
      params: ['volopIdDashSlug'],
    }),
    mainRouteGroup.route({
      path: `amp/${volopUrlSegment}/:volopIdDashSlug`,
      params: ['volopIdDashSlug'],
    }),
  ],
);

const mainVolopsSearchRouteReference = mainRouteGroup.route({
  path: ':segment',
  params: ['segment'],
  searchParams: ['q'],
});

export function getMainVolopsSearchRoutePath(data: {
  lang: UserLocale;
  q: string;
}) {
  const { lang, q } = data;
  const segment = HOME_PAGE_SLUGS.VOLOP[lang];

  return mainVolopsSearchRouteReference.with({ lang, segment, q });
}

// Grad Program

export const mainGradProgramSegmentedRoutes = GRAD_PROGRAM_URL_SEGMENTS.flatMap(
  (gradProgramUrlSegment) => [
    mainRouteGroup.route({
      path: `${gradProgramUrlSegment}/:programIdDashSlug`,
      params: ['programIdDashSlug'],
    }),
    mainRouteGroup.route({
      path: `amp/${gradProgramUrlSegment}/:programIdDashSlug`,
      params: ['programIdDashSlug'],
    }),
  ],
);
